import { createFeatureSelector, createSelector } from '@ngrx/store';
import { FeatureKeys } from './../app.reducer';

import * as fromReducer from './search-customers.reducer';

/* Selectors from the entity adapter */
export const {
    selectAll,
    selectEntities
} = fromReducer.adapter.getSelectors();
  
/* Selectors based on the feature state */
export const selectSearchCustomersFeature = createFeatureSelector<fromReducer.SearchCustomersState>(FeatureKeys.SEARCH_CUSTOMERS);

/* To select the appointments loading flag in the dashboard state */
export const selectCustomersLoading = createSelector(
    selectSearchCustomersFeature,
    (state: fromReducer.SearchCustomersState) => state.loading
);

export const selectCustomers = createSelector(
    selectSearchCustomersFeature,
    selectAll
);

export const selectCurrentCustomerEmail = createSelector(
    selectSearchCustomersFeature,
    (state: fromReducer.SearchCustomersState) => state.customerSelectedId
);

export const selectCurrentCustomer = createSelector(
    selectSearchCustomersFeature,
    (state: fromReducer.SearchCustomersState) => state.entities[state.customerSelectedId]
);

export const selectCustomersLoaded = createSelector(
    selectSearchCustomersFeature,
    (state: fromReducer.SearchCustomersState) => state.loaded
);

export const selectPendingSearchInput = createSelector(
    selectSearchCustomersFeature,
    (state: fromReducer.SearchCustomersState) => state.pendingSearchInput
);
